export default __webpack_public_path__ + "static/media/play-icon-black.4923ec74.svg";